import LocalizedStrings from "react-localization";

export const viewMappingDetailsMetadataStrings = new LocalizedStrings({
  en: {
    socialAccountName: "Social account name",
    mediaChannel: "Media channel",
    url: "Link",
    description: "Description",
  },
  fr: {
    socialAccountName: "Nom du Social Account",
    mediaChannel: "Support",
    url: "Lien",
    description: "Description",
  },
});
